/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AttachmentV1Dto } from '../models/AttachmentV1Dto';
import type { AttachmentV2Dto } from '../models/AttachmentV2Dto';
import type { DeleteManyRequestV1 } from '../models/DeleteManyRequestV1';
import type { DeleteManyResultV1 } from '../models/DeleteManyResultV1';
import type { EmailFilterInnerV2Dto } from '../models/EmailFilterInnerV2Dto';
import type { EmailListV1Dto } from '../models/EmailListV1Dto';
import type { EmailPaginatedV2Dto } from '../models/EmailPaginatedV2Dto';
import type { EmailStatusDto } from '../models/EmailStatusDto';
import type { EmailV1Dto } from '../models/EmailV1Dto';
import type { EmailV2Dto } from '../models/EmailV2Dto';
import type { OrderByPropertyDto } from '../models/OrderByPropertyDto';
import type { PatchAttachmentClassificationStatusV1Dto } from '../models/PatchAttachmentClassificationStatusV1Dto';
import type { PatchAttachmentClassificationStatusV2Dto } from '../models/PatchAttachmentClassificationStatusV2Dto';
import type { PatchEmailClassificationStatusV1Dto } from '../models/PatchEmailClassificationStatusV1Dto';
import type { PatchEmailClassificationStatusV2Dto } from '../models/PatchEmailClassificationStatusV2Dto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class EmailsService {
  /**
   * @returns EmailListV1Dto a entity list
   * @throws ApiError
   */
  public static emailControllerV1FindAllV1(): CancelablePromise<Array<EmailListV1Dto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/emails',
      errors: {
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @param requestBody
   * @returns DeleteManyResultV1 batch delete result
   * @throws ApiError
   */
  public static emailControllerV1RemoveManyV1(
    requestBody: DeleteManyRequestV1,
  ): CancelablePromise<DeleteManyResultV1> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v1/emails',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @param uuid emailId
   * @returns EmailV1Dto the entity
   * @throws ApiError
   */
  public static emailControllerV1FindOneV1(uuid: string): CancelablePromise<EmailV1Dto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/emails/{uuid}',
      path: {
        uuid: uuid,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * @param uuid emailId
   * @returns EmailV1Dto the entity
   * @throws ApiError
   */
  public static emailControllerV1RemoveOneV1(uuid: string): CancelablePromise<EmailV1Dto> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v1/emails/{uuid}',
      path: {
        uuid: uuid,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * @param ticketId
   * @returns EmailV1Dto a entity list
   * @throws ApiError
   */
  public static emailControllerV1FindManyByTicketIdV1(
    ticketId: string,
  ): CancelablePromise<Array<EmailV1Dto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/emails/ticket/{ticketId}',
      path: {
        ticketId: ticketId,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * @param uuid emailId
   * @param requestBody
   * @returns EmailV1Dto the update entity
   * @throws ApiError
   */
  public static emailControllerV1UpdatePartialEmailClassificationStatusV1(
    uuid: string,
    requestBody: PatchEmailClassificationStatusV1Dto,
  ): CancelablePromise<EmailV1Dto> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/v1/emails/{uuid}/status/classification',
      path: {
        uuid: uuid,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
        409: `Conflict - Version mismatch (optimistic locking). Entity was modified by another request.`,
      },
    });
  }
  /**
   * @param emailId emailId
   * @param attachmentId attachmentId
   * @param requestBody
   * @returns AttachmentV1Dto the update entity
   * @throws ApiError
   */
  public static emailControllerV1UpdatePartialAttachmentClassificationStatusV1(
    emailId: string,
    attachmentId: string,
    requestBody: PatchAttachmentClassificationStatusV1Dto,
  ): CancelablePromise<AttachmentV1Dto> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/v1/emails/{emailId}/attachment/{attachmentId}/status/classification',
      path: {
        emailId: emailId,
        attachmentId: attachmentId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
        409: `Conflict - Version mismatch (optimistic locking). Entity was modified by another request.`,
      },
    });
  }
  /**
   * @param filter Filter conditions for querying emails
   * @param orderBy Array of BaseEmailListDto order by properties
   * @param page Page number (starts at 1). Used for paginated queries. Must be a positive integer.
   * @param limit Number of items per page. Must be between 5 and 500. Used for paginated queries.
   * @param receiptDateFrom Filter by minimum receipt date (inclusive).
   * @param receiptDateTo Filter by maximum receipt date (inclusive).
   * @param isClassifiedFilter A filter to select emails based on their classification status. Use 'all' to include all emails, 'true' for only classified emails, or 'false' for only unclassified emails.
   * @param isEmailClassificationNotApplicable A filter to select emails based on their classificationNotApplicable flag. Use 'all' to include all emails, 'true' for only classified emails, or 'false' for only unclassified emails.
   * @param searchString A search string to filter BaseEmailListDto by given values.
   * @returns EmailPaginatedV2Dto a entity list wrapped with pagination result
   * @throws ApiError
   */
  public static emailControllerV2FindManyWithV2(
    filter?: EmailFilterInnerV2Dto | null,
    orderBy?: Array<OrderByPropertyDto> | null,
    page?: number,
    limit?: number,
    receiptDateFrom?: string,
    receiptDateTo?: string,
    isClassifiedFilter?: 'all' | 'true' | 'false',
    isEmailClassificationNotApplicable?: 'all' | 'true' | 'false',
    searchString?: string | null,
  ): CancelablePromise<EmailPaginatedV2Dto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v2/emails',
      query: {
        filter: filter,
        orderBy: orderBy,
        page: page,
        limit: limit,
        receiptDateFrom: receiptDateFrom,
        receiptDateTo: receiptDateTo,
        isClassifiedFilter: isClassifiedFilter,
        isEmailClassificationNotApplicable: isEmailClassificationNotApplicable,
        searchString: searchString,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @param requestBody
   * @returns DeleteManyResultV1 batch delete result
   * @throws ApiError
   */
  public static emailControllerV2RemoveManyV2(
    requestBody: DeleteManyRequestV1,
  ): CancelablePromise<DeleteManyResultV1> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v2/emails',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @returns EmailStatusDto Email statistics overview
   * @throws ApiError
   */
  public static emailControllerV2GetEmailMetricsV2(): CancelablePromise<EmailStatusDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v2/emails/metrics',
    });
  }
  /**
   * @param uuid emailId
   * @returns EmailV2Dto the entity
   * @throws ApiError
   */
  public static emailControllerV2FindOneV2(uuid: string): CancelablePromise<EmailV2Dto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v2/emails/{uuid}',
      path: {
        uuid: uuid,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * @param uuid emailId
   * @returns EmailV2Dto the entity
   * @throws ApiError
   */
  public static emailControllerV2RemoveOneV2(uuid: string): CancelablePromise<EmailV2Dto> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v2/emails/{uuid}',
      path: {
        uuid: uuid,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * @param ticketId
   * @returns EmailV2Dto a entity list
   * @throws ApiError
   */
  public static emailControllerV2FindManyByTicketIdV2(
    ticketId: string,
  ): CancelablePromise<Array<EmailV2Dto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v2/emails/ticket/{ticketId}',
      path: {
        ticketId: ticketId,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * @param uuid emailId
   * @param requestBody
   * @returns EmailV2Dto the update entity
   * @throws ApiError
   */
  public static emailControllerV2UpdatePartialEmailClassificationStatusV2(
    uuid: string,
    requestBody: PatchEmailClassificationStatusV2Dto,
  ): CancelablePromise<EmailV2Dto> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/v2/emails/{uuid}/status/classification',
      path: {
        uuid: uuid,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
        409: `Conflict - Version mismatch (optimistic locking). Entity was modified by another request.`,
      },
    });
  }
  /**
   * @param emailId emailId
   * @param attachmentId attachmentId
   * @param requestBody
   * @returns AttachmentV2Dto the update entity
   * @throws ApiError
   */
  public static emailControllerV2UpdatePartialAttachmentClassificationStatusV2(
    emailId: string,
    attachmentId: string,
    requestBody: PatchAttachmentClassificationStatusV2Dto,
  ): CancelablePromise<AttachmentV2Dto> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/v2/emails/{emailId}/attachment/{attachmentId}/status/classification',
      path: {
        emailId: emailId,
        attachmentId: attachmentId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
        409: `Conflict - Version mismatch (optimistic locking). Entity was modified by another request.`,
      },
    });
  }
  /**
   * @param id msGraphEmailId
   * @param forceDownload
   * @returns EmailV2Dto
   * @throws ApiError
   */
  public static msEmailControllerV1FetchEmailWithAttachmentAndStoreV1(
    id: string,
    forceDownload: boolean = false,
  ): CancelablePromise<EmailV2Dto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/emails/fetch-emails/{id}',
      path: {
        id: id,
      },
      query: {
        forceDownload: forceDownload,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
}
